import { EquipmentStatus } from '@/types';

export type EquipmentStatusColors = {
  bg: string;
  border: string;
  heading: string;
  text: string;
  badgeVariant: 'green' | 'orange' | 'yellow' | 'red';
  dotClass: string;
  layerClass: string;
  borderLeft: string;
  headerBg: string;
};

export const STATUS_COLOR_CLASSES: Record<EquipmentStatus, EquipmentStatusColors> = {
  'Not Operable': {
    bg: 'bg-red-50',
    border: 'border-red-300',
    heading: 'text-red-800',
    text: 'text-red-700',
    badgeVariant: 'red',
    dotClass: 'bg-red-500',
    layerClass: 'bg-red-500/25',
    borderLeft: 'border-l-red-400 dark:border-l-red-500',
    headerBg: 'bg-red-50/70 dark:bg-red-950/40',
  },
  'Needs Attention': {
    bg: 'bg-orange-50',
    border: 'border-orange-300',
    heading: 'text-orange-800',
    text: 'text-orange-700',
    badgeVariant: 'orange',
    dotClass: 'bg-orange-500',
    layerClass: 'bg-orange-500/25',
    borderLeft: 'border-l-orange-400 dark:border-l-orange-500',
    headerBg: 'bg-orange-50/70 dark:bg-orange-950/40',
  },
  Warning: {
    bg: 'bg-yellow-50',
    border: 'border-yellow-300',
    heading: 'text-yellow-800',
    text: 'text-yellow-700',
    badgeVariant: 'yellow',
    dotClass: 'bg-yellow-500',
    layerClass: 'bg-yellow-500/25',
    borderLeft: 'border-l-yellow-400 dark:border-l-yellow-500',
    headerBg: 'bg-yellow-50/70 dark:bg-yellow-950/40',
  },
  OK: {
    bg: 'bg-lime-50',
    border: 'border-lime-300',
    heading: 'text-lime-800',
    text: 'text-lime-700',
    badgeVariant: 'green',
    dotClass: 'bg-lime-500',
    layerClass: 'bg-lime-500/25',
    borderLeft: 'border-l-lime-400 dark:border-l-lime-500',
    headerBg: 'bg-lime-50/50 dark:bg-lime-950/30',
  },
};
